export default __webpack_public_path__ + "images/D1.27b6cba.png";